import gql from 'graphql-tag';

export const mutationDeleteSharedPublicLink = gql`
  mutation deleteSharedPublicLink (
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    deleteSharedPublicLink (
      integrationID: $integrationID
      remoteID: $remoteID
    )
  }
`;
export default mutationDeleteSharedPublicLink;
